<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="560"
    width="100%"
    style="z-index: 290"
    @keydown.enter="agree"
  >
    <v-alert
      colored-border
      border="left"
      prominent
      :color="color"
      :icon="icon"
      class="mb-0"
    >
      <v-row align="center">
        <v-col class="grow">
          {{ message }}
        </v-col>
        <v-col class="shrink">
          <v-btn block text class="mb-2" outlined :color="color" @click="agree"
            >ja</v-btn
          >
          <v-btn block @click="cancel" outlined text plain>nein</v-btn>
        </v-col>
      </v-row>
    </v-alert>
  </v-dialog>
</template>

<script>
import { defineComponent } from "vue";
/**
 * Vuetify Confirm Dialog component
 * https://gist.github.com/eolant/ba0f8a5c9135d1a146e1db575276177d
 *
 * Insert component where you want to use it:
 * <confirm ref="confirm"></confirm>
 *
 * Call it:
 * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {})
 * Or use await:
 * if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
 *   // yes
 * }
 * else {
 *   // cancel
 * }
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
 * <template>
 *   <v-app>
 *     ...
 *     <confirm ref="confirm"></confirm>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$confirm = this.$refs.confirm.open
 * }
 */
export default defineComponent({
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: "",
    color: "primary",
    icon: "mdi-information",
  }),
  methods: {
    open(args) {
      this.dialog = true;
      if (args.message) {
        this.message = args.message;
      }
      if (args.color) {
        this.color = args.color;
      }
      if (args.icon) {
        this.icon = args.icon;
      }

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
});
</script>
